import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';
import { PUBLIC_ROUTES } from '../constants/app.constants';

export const SpecificSignInGuard: CanActivateFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    // usuario no logueado o token caducado --> redirigir a login
    if (!auth.isUserLoggedIn()) {
        return router.createUrlTree([`/${PUBLIC_ROUTES.login}`]);
    }

    const token = auth.getDecodedToken();

    // usuario logueado + no tiene rol --> permitir acceso
    if (!token.role) {
        return true;
    }

    // usuario logueado + tiene rol --> redirigir al calendario
    return router.createUrlTree([auth.homeRoute()]);
};
